import { NgTemplateOutlet, ViewportScroller } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { LgButtonComponent } from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { LinkCheck } from "../../../services/link-check/link-check.service";

import { GlobalState } from "../../../store/global/global.reducer";
import { selectBaseHref } from "../../../store/global/global.selectors";

@Component({
  selector: "dotcom-frontend-link",
  templateUrl: "./Link.component.html",
  standalone: true,
  imports: [LgButtonComponent, NgTemplateOutlet, RouterLink]
})
export class LinkComponent implements OnInit {
  @Input() url: any;
  @Input() linkClass: any;
  @Input() role = "";
  @Input() target: string | undefined;
  @Input() title = "";
  @Input() extension = "";
  @Input() fileSize = "";
  @Input() tabindex: number | undefined | null;
  @Input() arialabel: string | undefined;
  @Input() isLgButton = false;
  @Input() lgButtonVariant: any;
  @Input() lgButtonIconPosition: any;
  @Input() adobeData: any | undefined;
  baseHref = "";
  isExternalLink = false;
  isExternalDomain = false;
  isFileLink = false;
  fileExtensions: string[] = [
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx"
  ];
  formattedUrl = "";
  unavailableLink = false;
  isEditMode = false;
  baseHref$: Observable<string> = this.store.select(selectBaseHref);

  constructor(
    private store: Store<{ global: GlobalState }>,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private linkCheck: LinkCheck,
    private viewportScroller: ViewportScroller
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params["epieditmode"]) {
        // this is set to false for now see LGCOM-6918
        this.isEditMode = false;
      }
    });

    this.baseHref$.subscribe((baseHref) => {
      this.baseHref = baseHref;
    });
  }

  ngOnInit() {
    if (!this.target) {
      this.target = "_self";
    }

    if (this.url?.match(/\/#(?!.*\/)/)) {
      this.url = this.url.replace("/#", "#");
      this.isExternalLink = true;
    } else {
      this.isExternalLink = !this.url?.startsWith(this.baseHref);
    }

    this.formattedUrl = !this.isExternalLink
      ? this.url?.replace(this.baseHref, "")
      : this.url;

    this.unavailableLink = this.linkCheck.linkUnavailableCheck(this.url);

    this.isFileLink = this.fileExtensions.some((ext) =>
      this.url?.endsWith(ext)
    );

    const strippedBaseHref = this.baseHref.replace("www.", "");
    const strippedUrl = this.url?.replace("www.", "");

    this.isExternalDomain =
      strippedUrl && !strippedUrl?.startsWith(strippedBaseHref);

    if (this.isExternalDomain || this.isFileLink) {
      this.target = "_blank";
    }
  }

  navigate(event: any) {
    if (window.top && this.isEditMode) {
      event.preventDefault();
      window.top.location.href =
        "https://cms.legalandgeneralre.com/EPiServer/CMS/#context=epi.cms.contentdata:///5049&viewsetting=viewlanguage:///en";
    }

    if (this.url && this.url.startsWith("#")) {
      event.preventDefault();
      this.viewportScroller.scrollToAnchor(this.url.replace("#", ""));
    }
  }

  linkUnavailableCheck(url: string): boolean {
    return this.linkCheck.linkUnavailableCheck(url);
  }

  interactionClickEvent(adobeData: any | undefined) {
    if (adobeData) {
      this.analyticsService.adobeInteractionEvent(
        adobeData.interactionContainer,
        adobeData.interactionLink,
        adobeData.interactionName,
        adobeData.interactionRegion,
        adobeData.interactionType,
        adobeData.interactionPage,
        adobeData.interactionDetails
      );
    }
  }
}
